import { useMemo } from 'react';
import { LocalModelSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): LocalModelSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return LocalModelSortingField.Company;

        case 'identifier':
            return LocalModelSortingField.Identifier;

        case 'name':
            return LocalModelSortingField.Name;

        case 'order':
            return LocalModelSortingField.Order;

        case 'isActive':
            return LocalModelSortingField.IsActive;

        case 'submodels':
            return LocalModelSortingField.Submodels;

        case 'variants':
            return LocalModelSortingField.Variants;

        case 'make':
            return LocalModelSortingField.MakeName;

        case 'bodyType':
            return LocalModelSortingField.BodyType;

        case 'parentModel':
            return LocalModelSortingField.ParentModelName;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === LocalModelSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const identifierSort = useMemo(
        () => (sort.field === LocalModelSortingField.Identifier ? sort.orderValue : undefined),
        [sort]
    );

    const nameSort = useMemo(() => (sort.field === LocalModelSortingField.Name ? sort.orderValue : undefined), [sort]);

    const orderSort = useMemo(
        () => (sort.field === LocalModelSortingField.Order ? sort.orderValue : undefined),
        [sort]
    );

    const activeSort = useMemo(
        () => (sort.field === LocalModelSortingField.IsActive ? sort.orderValue : undefined),
        [sort]
    );

    const subModelSort = useMemo(
        () => (sort.field === LocalModelSortingField.Submodels ? sort.orderValue : undefined),
        [sort]
    );

    const variantSort = useMemo(
        () => (sort.field === LocalModelSortingField.Variants ? sort.orderValue : undefined),
        [sort]
    );

    const makeSort = useMemo(
        () => (sort.field === LocalModelSortingField.MakeName ? sort.orderValue : undefined),
        [sort]
    );

    const bodyTypeSort = useMemo(
        () => (sort.field === LocalModelSortingField.BodyType ? sort.orderValue : undefined),
        [sort]
    );

    const parentModelNameSort = useMemo(
        () => (sort.field === LocalModelSortingField.ParentModelName ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        nameSort,
        identifierSort,
        orderSort,
        activeSort,
        subModelSort,
        variantSort,
        makeSort,
        bodyTypeSort,
        parentModelNameSort,
    };
};

export default useSortOrder;
